import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./realestate.css";
import HeroFooter from "../../components/footer";
import ScrollToTop from "./scrolltop";

const categories = [
  "Contract Management",
  "Foreign Collaborations",
  "Joint Ventures",
  "Corporate Law",
  "Information Technology",
  "Business Ventures",
  "MSME",
  "Start-up India Initiatives",
  "Property and Real Estate"
];

// Map each category to a custom slug
const categoryMapping = {
  "Contract Management": "contract",
  "Foreign Collaborations": "foreign",
  "Joint Ventures": "joint",
  "Corporate Law": "corporate",
  "Information Technology": "information",
  "Business Ventures": "buisness",
  "MSME": "msme",
  "Start-up India Initiatives": "startup",
  "Property and Real Estate": "realestate"
};

const BusinessVentures = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  
  return (
    <div className="practice-page">
      <ScrollToTop />
      {/* Mobile Menu Button visible on mobile */}
      <div className="mobile-menu-button" onClick={toggleSidebar}>
        <i className="fa fa-bars" aria-hidden="true"></i>
      </div>
      
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <h2 className="sidebar-title">Our Offerings</h2>
        <ul className="category-list">
          {categories.map((category, index) => (
            <li 
              key={index}
              className={category === "Business Ventures" ? "active" : ""}
            >
             <Link
  onClick={() => {
    setTimeout(() => setSidebarOpen(false), 100); // slight delay
  }}
  to={`/${categoryMapping[category]}`}
>
  {category}
</Link>
            </li>
          ))}
        </ul>
      </aside>
      
      {/* Main Content */}
      <main className="conten">
        <h2>Business Ventures</h2>
        <p className="intro">
          At InduratnaLaw, we empower entrepreneurs and established businesses alike with strategic legal support that fosters growth and innovation.
        </p>
        <section className="details">
          <h3>Our Expertise</h3>
          <p>
            We guide businesses from startup ideation to scaling operations through comprehensive legal advice. Our services cover everything from entity formation to complex corporate transactions.
          </p>
          <h3>Key Services</h3>
          <ul>
            <li>Business Formation and Structuring</li>
            <li>Contract Drafting and Negotiation</li>
            <li>Financial and Regulatory Advisory</li>
            <li>Strategic Growth and Expansion Support</li>
            <li>Dispute Resolution and Risk Mitigation</li>
          </ul>
          <h3>Why Choose InduratnaLaw?</h3>
          <p>
            Our client-centric approach and extensive industry expertise ensure that every venture receives tailored legal strategies designed to secure long-term success.
          </p>
        </section>
      </main>
      <HeroFooter />
    </div>
  );
};

export default BusinessVentures;
